"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cartesian2dPlotSharedQuadTree = void 0;
const rc_js_util_1 = require("rc-js-util");
const cartesian2d_interaction_handler_1 = require("./cartesian2d-interaction-handler");
const core_1 = require("@visualization-tools/core");
/**
 * @public
 * Default interaction groups implemented using a shared quad tree.
 */
class Cartesian2dPlotSharedQuadTree {
    constructor(plot, options) {
        this.plot = plot;
        this.options = options;
        this.temporaryListeners = new rc_js_util_1.TemporaryListener();
        this.interactionGroups = new core_1.DefaultInteractionGroups(plot.updateArgProvider, plot);
    }
    setQuadTreeInteractionHandler(emscriptenWrapper, chart, listeners = {}) {
        const entityTree = new core_1.SharedEntityQuadTree(emscriptenWrapper, 12, 4);
        this.populateTree(entityTree);
        this.configureListeners(entityTree);
        this.plot.setInteractionHandler(new core_1.PlotInteractionConnector(() => new cartesian2d_interaction_handler_1.Cartesian2dInteractionHandler(chart, this.plot, listeners)), () => new core_1.QuadTreeEventTargetProvider(entityTree, this.plot, this.interactionGroups, this.options), core_1.getChartInitialState);
    }
    clearInteractionHandler() {
        this.plot.clearInteractionHandler();
    }
    populateTree(entityTree) {
        const existingEntities = this.plot.getEntitiesInGroup(this.interactionGroups.hitTestable);
        for (let i = 0, iEnd = existingEntities.length; i < iEnd; ++i) {
            entityTree.addEntity(existingEntities[i]);
        }
    }
    configureListeners(entityTree) {
        core_1.OnPlotAttachChanged.registerOneTimeListener(this.plot, (isAttached) => {
            if (!isAttached) {
                entityTree.sharedObject.release();
                this.temporaryListeners.clearListeners();
            }
        });
        this.temporaryListeners.addListener(core_1.OnEntityAddedToGroup.registerListener(this.plot, (entity) => {
            if (this.interactionGroups.hitTestable.isEntityInGroup(entity)) {
                entityTree.addEntity(entity);
            }
        }));
        this.temporaryListeners.addListener(core_1.OnEntityRemovedFromGroup.registerListener(this.plot, (entity) => {
            if (this.interactionGroups.hitTestable.isEntityInGroup(entity)) {
                entityTree.removeEntity(entity);
            }
        }));
        this.temporaryListeners.addListener(core_1.OnEntityRemoved.registerListener(this.plot, (entity) => {
            if (this.interactionGroups.hitTestable.isEntityInGroup(entity)) {
                entityTree.removeEntity(entity);
            }
        }));
    }
}
exports.Cartesian2dPlotSharedQuadTree = Cartesian2dPlotSharedQuadTree;
//# sourceMappingURL=cartesian2d-plot-shared-quad-tree.js.map